export default __webpack_public_path__ + "static/media/Tizen.1e44cbfe.png";